// Single-product page interactions:
//   - thumbnail click swaps the main image + updates the "1/4" indicator
//   - quantity stepper +/- buttons (local intent only — doesn't touch
//     the cart until the user clicks Add to Cart / Buy Now)
//   - Add to Cart  → POST haegoziya_set_qty?mode=add → toast confirmation
//                    + live header cart count update via Woo fragments
//   - Buy Now      → same AJAX, then redirect to /cart/
//   - Wish list toggle (visual state only; persistence handled by the
//     existing wishlist module)
//
// All buttons disable themselves while a request is in-flight so users
// can't double-fire.

// ── Gallery thumbnail switcher + click-to-zoom lightbox ────────
//   Bug fixed: WP emits `srcset` on the main <img>, which overrides
//   plain `src` updates. We clear srcset + sizes on every swap so
//   the browser actually paints the new image.
document.querySelectorAll('[data-gallery]').forEach(g => {
    const main    = g.querySelector('[data-gallery-main] img');
    const counter = g.querySelector('[data-gallery-count]');
    const thumbs  = Array.from(g.querySelectorAll('[data-gallery-thumb]'));
    const moreBtn = g.querySelector('[data-gallery-more]');
    const total   = thumbs.length + (moreBtn ? 1 : 0);
    if (!main) return;

    // Pre-populate thumb #1 with the main image's data-large fallback
    // so the lightbox can open from index 0 even when there are no
    // gallery siblings (single-image products).
    if (thumbs.length === 0) {
        thumbs.push({ dataset: { large: main.currentSrc || main.src }, classList: { add: () => {}, remove: () => {} } });
    }

    const setActive = (idx) => {
        const t = thumbs[idx];
        if (!t) return;
        const large = t.dataset.large;
        if (large) {
            // Clearing srcset/sizes is what makes the swap actually
            // render — otherwise the browser keeps painting from srcset.
            main.removeAttribute('srcset');
            main.removeAttribute('sizes');
            main.src = large;
        }
        thumbs.forEach(x => x.classList && x.classList.remove('is-active'));
        if (t.classList) t.classList.add('is-active');
        if (counter) counter.textContent = `${idx + 1}/${Math.max(total, 1)}`;
    };

    thumbs.forEach((t, i) => {
        if (t.addEventListener) t.addEventListener('click', () => setActive(i));
    });

    if (moreBtn) {
        let cycle = 0;
        moreBtn.addEventListener('click', () => {
            cycle = (cycle + 1) % thumbs.length;
            setActive(cycle);
        });
    }

    // ── Click main image → open zoom lightbox ────────────────────
    main.style.cursor = 'zoom-in';
    main.addEventListener('click', () => {
        const url = main.currentSrc || main.src;
        if (!url) return;
        openLightbox(url, thumbs.map(t => t.dataset && t.dataset.large).filter(Boolean));
    });
});

// ── Zoom lightbox ───────────────────────────────────────────────
//   Full-screen overlay with the image at natural size, supporting:
//     - click outside / Esc / × button → close
//     - click image / + / − / scroll wheel → zoom in/out
//     - drag-to-pan when zoomed in
//     - left/right arrow keys → navigate between gallery images
let lb;
function buildLightbox() {
    lb = document.createElement('div');
    lb.className = 'gallery-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = `
        <button type="button" class="gallery-lightbox__close" aria-label="Close">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M6 18L18 6"/></svg>
        </button>
        <button type="button" class="gallery-lightbox__nav gallery-lightbox__nav--prev" aria-label="Previous">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>
        </button>
        <button type="button" class="gallery-lightbox__nav gallery-lightbox__nav--next" aria-label="Next">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>
        </button>
        <div class="gallery-lightbox__stage" data-stage>
            <img class="gallery-lightbox__img" alt="">
        </div>
        <div class="gallery-lightbox__controls">
            <button type="button" data-zoom-out aria-label="Zoom out">−</button>
            <span data-zoom-level>100%</span>
            <button type="button" data-zoom-in aria-label="Zoom in">+</button>
            <button type="button" data-zoom-reset aria-label="Reset zoom">Reset</button>
        </div>
    `;
    document.body.appendChild(lb);
    return lb;
}

let zoom = 1;
let panX = 0;
let panY = 0;
let dragStart = null;
let imgs = [];
let idx  = 0;

function paint() {
    const img = lb.querySelector('.gallery-lightbox__img');
    img.style.transform = `translate(${panX}px, ${panY}px) scale(${zoom})`;
    const lbl = lb.querySelector('[data-zoom-level]');
    if (lbl) lbl.textContent = `${Math.round(zoom * 100)}%`;
}

function loadImg(i) {
    if (!imgs.length) return;
    idx = ((i % imgs.length) + imgs.length) % imgs.length;
    const img = lb.querySelector('.gallery-lightbox__img');
    img.src = imgs[idx];
    zoom = 1; panX = 0; panY = 0;
    paint();
}

function openLightbox(src, all) {
    if (!lb) buildLightbox();
    imgs = (all && all.length) ? all : [src];
    idx  = Math.max(0, imgs.indexOf(src));
    loadImg(idx);
    lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
}

function closeLightbox() {
    if (!lb) return;
    lb.classList.remove('is-open');
    document.body.style.overflow = '';
}

document.addEventListener('click', e => {
    if (!lb) return;
    if (e.target.closest('.gallery-lightbox__close'))           closeLightbox();
    else if (e.target.closest('[data-zoom-in]'))                 { zoom = Math.min(4, zoom + 0.25); paint(); }
    else if (e.target.closest('[data-zoom-out]'))                { zoom = Math.max(1, zoom - 0.25); if (zoom === 1) { panX = panY = 0; } paint(); }
    else if (e.target.closest('[data-zoom-reset]'))              { zoom = 1; panX = panY = 0; paint(); }
    else if (e.target.closest('.gallery-lightbox__nav--prev'))   loadImg(idx - 1);
    else if (e.target.closest('.gallery-lightbox__nav--next'))   loadImg(idx + 1);
    else if (e.target === lb)                                    closeLightbox();
});

document.addEventListener('keydown', e => {
    if (!lb || !lb.classList.contains('is-open')) return;
    if (e.key === 'Escape')     closeLightbox();
    if (e.key === 'ArrowLeft')  loadImg(idx - 1);
    if (e.key === 'ArrowRight') loadImg(idx + 1);
    if (e.key === '+' || e.key === '=') { zoom = Math.min(4, zoom + 0.25); paint(); }
    if (e.key === '-')                  { zoom = Math.max(1, zoom - 0.25); if (zoom === 1) panX = panY = 0; paint(); }
});

// Wheel = zoom in/out; click image = zoom in step-by-step.
document.addEventListener('wheel', e => {
    if (!lb || !lb.classList.contains('is-open')) return;
    if (!e.target.closest('.gallery-lightbox__stage')) return;
    e.preventDefault();
    zoom = Math.max(1, Math.min(4, zoom + (e.deltaY < 0 ? 0.15 : -0.15)));
    if (zoom === 1) panX = panY = 0;
    paint();
}, { passive: false });

document.addEventListener('mousedown', e => {
    if (!lb || !lb.classList.contains('is-open')) return;
    const img = e.target.closest('.gallery-lightbox__img');
    if (!img) return;
    if (zoom <= 1) { zoom = 2; paint(); return; }
    dragStart = { x: e.clientX - panX, y: e.clientY - panY };
    img.style.cursor = 'grabbing';
});
document.addEventListener('mousemove', e => {
    if (!dragStart) return;
    panX = e.clientX - dragStart.x;
    panY = e.clientY - dragStart.y;
    paint();
});
document.addEventListener('mouseup', () => {
    if (!dragStart) return;
    dragStart = null;
    const img = lb && lb.querySelector('.gallery-lightbox__img');
    if (img) img.style.cursor = zoom > 1 ? 'grab' : 'zoom-in';
});

// ── Quantity steppers ───────────────────────────────────────────
//   Local intent only. Doesn't hit the cart until Add to Cart / Buy
//   Now fires. Resting state is 1 — a "0" next to Buy Now reads like
//   ordering nothing and confused shoppers, so the stepper never drops
//   below a single unit.
document.querySelectorAll('[data-qty-stepper]').forEach(stepper => {
    const input = stepper.querySelector('input');
    const inc   = stepper.querySelector('[data-qty-inc]');
    const dec   = stepper.querySelector('[data-qty-dec]');
    if (!input) return;
    const clamp = v => Math.max(1, Math.min(999, isNaN(v) ? 1 : v));

    inc?.addEventListener('click', () => {
        input.value = clamp(parseInt(input.value, 10) + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    dec?.addEventListener('click', () => {
        input.value = clamp(parseInt(input.value, 10) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
    });
});

// ── Wish list toggle (visual only) ──────────────────────────────
document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
        const pressed = btn.getAttribute('aria-pressed') === 'true';
        btn.setAttribute('aria-pressed', String(!pressed));
    });
});

// ── Cart toast ───────────────────────────────────────────────────
let toastEl;
function showCartToast(msg, variant = 'ok') {
    if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'cart-toast';
        document.body.appendChild(toastEl);
    }
    toastEl.dataset.variant = variant;
    toastEl.innerHTML = `
        <span class="cart-toast__icon" aria-hidden="true">
            ${variant === 'err'
                ? '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h0"/></svg>'
                : '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4 4 10-10"/></svg>'}
        </span>
        <span class="cart-toast__msg">${msg}</span>
        <a class="cart-toast__cta" href="/cart/">View cart →</a>
    `;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 3600);
}

// ── Variation selector (variable products) ──────────────────────
//   Clicking a weight pill updates the form's variation_id +
//   attributes, swaps the price in real time, and updates the
//   pressed-state on the pill.
document.querySelectorAll('.product-variations').forEach(group => {
    const form     = group.closest('.product-info__cart')
                  || document.querySelector('.product-info__cart');
    const priceEl  = document.querySelector('[data-product-price]');
    if (!form) return;

    group.querySelectorAll('[data-variation-id]').forEach(pill => {
        pill.addEventListener('click', () => {
            if (pill.disabled) return;
            group.querySelectorAll('[data-variation-id]').forEach(p => {
                p.classList.remove('is-active');
                p.setAttribute('aria-pressed', 'false');
            });
            pill.classList.add('is-active');
            pill.setAttribute('aria-pressed', 'true');

            // Update form data so Add to Cart / Buy Now send the right
            // variation_id + attributes payload.
            form.dataset.variationId    = pill.dataset.variationId || '0';
            form.dataset.variationAttrs = pill.dataset.variationAttrs || '{}';

            // Live-swap the displayed price.
            if (priceEl && pill.dataset.variationPrice) {
                priceEl.innerHTML = pill.dataset.variationPrice;
            }
        });
    });
});

// ── Add to Cart / Buy Now AJAX flow ─────────────────────────────
async function postQty({ productId, variationId, quantity, attributes = {}, mode = 'add' }) {
    const cfg = window.HAEGOZIYA || {};
    const body = new FormData();
    body.append('action',       'haegoziya_set_qty');
    body.append('nonce',        cfg.qtyNonce || '');
    body.append('product_id',   String(productId));
    body.append('variation_id', String(variationId || 0));
    body.append('quantity',     String(quantity));
    body.append('mode',         mode);
    for (const [k, v] of Object.entries(attributes || {})) {
        body.append('attributes[' + k + ']', v);
    }

    const res = await fetch(cfg.ajaxUrl || '/wp-admin/admin-ajax.php', {
        method: 'POST',
        credentials: 'same-origin',
        body,
    });
    const json = await res.json().catch(() => null);
    if (!res.ok || !json || !json.success) {
        const err = (json && json.data && json.data.message) || 'Cart update failed';
        throw new Error(err);
    }
    return json.data;
}

function applyFragments(fragments) {
    if (!fragments) return;
    for (const [selector, html] of Object.entries(fragments)) {
        document.querySelectorAll(selector).forEach(el => { el.outerHTML = html; });
    }
}

function tellWooCartChanged() {
    // Existing Woo listeners (mini-cart, account widgets) react to these.
    if (window.jQuery) {
        window.jQuery(document.body).trigger('wc_fragment_refresh');
        window.jQuery(document.body).trigger('added_to_cart');
    }
}

async function handleCartClick(form, { redirect = null, btn = null } = {}) {
    if (!form) return;
    const productId   = parseInt(form.dataset.productId, 10);
    const variationId = parseInt(form.dataset.variationId || '0', 10) || 0;
    const input       = form.querySelector('.qty-stepper__input');
    if (!productId || !input) return;

    let attributes = {};
    try { attributes = JSON.parse(form.dataset.variationAttrs || '{}'); } catch (_) {}

    let qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 1) qty = 1;          // sane default if user hasn't touched the stepper

    if (btn) btn.disabled = true;
    try {
        const data = await postQty({ productId, variationId, quantity: qty, attributes, mode: 'add' });
        applyFragments(data.fragments);
        tellWooCartChanged();

        if (redirect) {
            window.location.href = redirect;
            return;
        }
        showCartToast(`Added ${qty} to cart · ${data.total_qty} item${data.total_qty === 1 ? '' : 's'}`);
        // Reset stepper back to a single unit after a successful add.
        input.value = 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {
        showCartToast(e.message || 'Could not add to cart', 'err');
    } finally {
        if (btn) btn.disabled = false;
    }
}

document.querySelectorAll('.product-info__cart').forEach(form => {
    const addBtn = form.querySelector('[data-add-to-cart]');
    const buyBtn = form.querySelector('[data-buy-now]');
    const cartUrl = form.dataset.cartUrl || '/cart/';

    addBtn?.addEventListener('click', () => handleCartClick(form, { btn: addBtn }));
    buyBtn?.addEventListener('click', () => handleCartClick(form, { btn: buyBtn, redirect: cartUrl }));

    // If the form is somehow submitted (e.g. Enter key in the stepper),
    // intercept and run the AJAX flow instead of a full page POST.
    form.addEventListener('submit', e => {
        e.preventDefault();
        handleCartClick(form, { btn: addBtn });
    });
});
